<template lang="pug">
#location-card
  .card(v-if="account.id")
    .card-image
      figure.image
        google-map(
          :name="account._embedded.location.id"
          :location="account._embedded.location"
        )
    .card-content
      h4.is-font-size-4.has-text-weight-semibold {{ account.organization }}
      address
        span {{ account._embedded.location.address.number_and_route }}
        br
        span {{ account._embedded.location.address.locality }}, {{ account._embedded.location.address.administrative_area_level_1 }} {{ account._embedded.location.address.postal_code }}
      .level
        .level-left
          .level-item
            b-icon(icon="phone" size="is-small")
            small (949) 581-5070
          .level-item
            b-icon(icon="email-outline" size="is-small")
            small
              a(href="mailto:office@foothillfamily.com") office@foothillfamily.com
</template>

<script>
import { mapGetters } from 'vuex';
import GoogleMap from '@/components/GoogleMap.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'location-card',
  components: {
    GoogleMap,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
    }),
  },
};
</script>

<style lang="scss" scoped>
#location-card {
  .card {
    box-shadow: $box-shadow;
    .card-image .image {
      height: 200px;
    }
  }
  address {
    font-style: normal;
    margin-bottom: 0.75rem;
  }
  .level {
    span.icon {
      margin-right: 0.25rem;
    }
    &, a {
      color: $theme-grey;
    }
  }
}
@media (max-width: $tablet) {
  #location-card {
    .level {
      .level-item {
        justify-content: flex-start;
      }
    }
  }
}
</style>
